import {useEffect, useState} from "react";
import {getAllBrandsObject} from "../../pages/brands/functions";
import {TreeSelectWithoutContainer} from "../TreeSelect/TreeSelect";
import {listToTree} from "../../assets/functions";
import Loading from "../Loading/Loading";
import {getAllProductCategoriesObject} from "../../pages/ProductCategories/functions";
import { getAllProductsObject} from "../../pages/Products/functions";

const ExceptionGoodForm = ({exceptionGood , onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [allBrands, setAllBrands] = useState([]);
    const [allProductCategories, setAllProductCategories] = useState([]);
    const [allProductsForInclude, setAllProductsForInclude] = useState([]);
    const [allProductsForExclude, setAllProductsForExclude] = useState([]);

    const changeExceptionGood =(key , value) => {
        const newExceptionGood = {...exceptionGood};
        newExceptionGood[key] = [...value];
        onChange(newExceptionGood);
    }

    useEffect(() => {
        (async () => {
            setAllProductCategories(await getAllProductCategoriesObject());
            setAllBrands(await getAllBrandsObject());
            setAllProductsForInclude(await getAllProductsObject("?length=ALL"));
            setAllProductsForExclude(await getAllProductsObject("?length=ALL"));
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className={"row"}>
            <div className="card">
                <div className="card-body">
                    <label className={"card-title d-block"}>دسترسی ها و محدودیت ها</label>

                    <label className={"card-title d-block mt-4"}><small>دسته بندی ها قابل دسترسی</small></label>
                    <TreeSelectWithoutContainer data={listToTree(allProductCategories, exceptionGood.includeCategory)}
                                                onChange={(value) => {
                                                    changeExceptionGood("includeCategory", value)
                                                }}/>

                    <label className={"card-title d-block mt-4"}><small>برندهای قابل دسترسی</small></label>
                    <TreeSelectWithoutContainer data={listToTree(allBrands, exceptionGood.includeBrand)}
                                                onChange={(value) => {
                                                    changeExceptionGood("includeBrand", value)
                                                }}/>

                    <label className={"card-title d-block mt-4"}><small>محصولات قابل دسترسی</small></label>
                    <TreeSelectWithoutContainer data={listToTree(allProductsForInclude, exceptionGood.includeProduct)}
                                                onChange={(value) => {
                                                    changeExceptionGood("includeProduct", value)
                                                }}/>

                    <label className={"card-title d-block mt-4"}><small className={"text-danger"}>محصولات غیر قابل دسترس</small></label>
                    <TreeSelectWithoutContainer data={listToTree(allProductsForExclude, exceptionGood.excludeProduct)}
                                                onChange={(value) => {
                                                    changeExceptionGood("excludeProduct", value)
                                                }}/>


                </div>
            </div>
        </div>
    )
}

export default ExceptionGoodForm;